
import { useState } from 'react'
import { Modal, Box, Typography, IconButton } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import SoftwareCard from './SoftwareCard'
import { allSoftwares } from '../helpers/Softwarelisting'
import { DocumentList } from '../helpers/enums'
import IntroCart from './IntroCart'
import './PricingCalculator.css'

const SOFTWARE_PRICING = 10

const PricingCalculator = ({ open, handleClose }) => {
  const [cart, setCart] = useState([])
  const [teamSize, setTeamSize] = useState(1)

  const handleAddToCart = (software) => {
    const name = DocumentList[software]?.name || software
    setCart((prevCart) => {
      const existing = prevCart.find((item) => item.name === name)
      if (existing) return prevCart
      return [...prevCart, { name, price: SOFTWARE_PRICING, qty: 1, software }]
    })
  }

  const handleRemoveFromCart = (software) => {
    const name = DocumentList[software]?.name || software
    setCart((prevCart) => {
      const existing = prevCart.find((item) => item.name === name)
      if (!existing) return prevCart
      if (existing.qty <= 1) {
        return prevCart.filter((item) => item.name !== name)
      }
      return prevCart.map((item) => (item.name === name ? { ...item, qty: item.qty - 1 } : item))
    })
  }

  const handleDeleteFromCart = (software) => {
    const name = DocumentList[software]?.name || software
    setCart((prevCart) => prevCart.filter((item) => item.name !== name))
  }

  const handleTeamSizeChange = (e) => {
    const value = Math.max(1, Number.parseInt(e.target.value) || 1)
    setTeamSize(value)
  }

  const total = cart.reduce((sum, item) => sum + item.price * item.qty, 0) * teamSize

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="pricing-calculator-modal"
      aria-describedby="pricing-calculator-description"
      className="pricing-modal"
    >
      <Box className="modal-container">
        {/* Header */}
        <Box className="modal-header">
          <Box className="team-size-section">
            <Typography className="team-size-label">Team Size:</Typography>
            <input type="number" min={1} value={teamSize} onChange={handleTeamSizeChange} className="team-size-input" />
            <Typography className="pricing-text">$10/user/month</Typography>
          </Box>
          <IconButton onClick={handleClose} className="close-button" aria-label="close">
            <CloseIcon />
          </IconButton>
        </Box>

        {/* Content */}
        <Box className="modal-content">
          {/* Software List */}
          <Box className="software-section-list1">
            {allSoftwares.map((software) => {
              const name = DocumentList[software]?.name || software
              const cartItem = cart.find((item) => item.name === name)
              return (
                <SoftwareCard
                  key={software}
                  name={name}
                  price={SOFTWARE_PRICING}
                  qty={cartItem?.qty || 0}
                  onAddToCart={() => handleAddToCart(software)}
                  onRemoveFromCart={() => handleRemoveFromCart(software)}
                  isInCart={!!cartItem}
                />
              )
            })}
          </Box>

          {/* Divider */}
          <Box className="content-divider" />

          {/* Cart */}
          <Box className="cart-section">
            <IntroCart cart={cart} total={total} onDelete={handleDeleteFromCart} />
          </Box>
        </Box>
      </Box>
    </Modal>
  )
}

export default PricingCalculator
